import React from 'react';
import PropTypes from 'prop-types';

const WarningLabel = ({ warning }) => {
  const number = warning.split(" ")[0];
  const message = warning.split(" ").splice(1).join(" ");

  return (
    <div className="warning-label">
      <span><b>{number}</b> ({message})</span>
    </div>
  );
};

WarningLabel.propTypes = {
  warning: PropTypes.string.isRequired
};

export default WarningLabel;
